module.exports = __webpack_public_path__ + "img/Boy_020014.2825b5f5.png";